<template>
    <div class="box box-default">
        <div class="box-header with-border" v-if="header || $slots.header">
            <slot name="header" :text="header">
                <h3 class="box-title">
                    {{ header }}
                </h3>
            </slot>
            <div class="box-tools pull-right" v-if="$slots.tools || showCloseButton">
                <slot name="tools"></slot>
                <button v-if="showCloseButton" type="button" class="btn btn-box-tool" @click="$emit('close')">
                    <span class="fa fa-times"></span>
                </button>
            </div>
        </div>
        <div class="box-body" :class="{ 'no-padding': noPadding }">
            <slot></slot>
        </div>
        <div class="box-footer" v-if="$slots.footer">
            <slot name="footer"></slot>
        </div>
        <div class="overlay" v-if="loading">
            <span class="fa fa-refresh fa-spin"></span>
        </div>
        <div class="overlay upload-overlay">
            <span class="fa fa-upload"></span>
        </div>
    </div>
</template>

<style>
.upload-overlay {
    display: none;
    pointer-events: none;
}

.drag-over .upload-overlay {
    display: block;
}
</style>

<script>
export default {
    props: ['header', 'loading', 'showCloseButton', 'noPadding'],
}
</script>
